export default {"src":"/_next/static/media/BA.3168a75b.svg","height":18,"width":18};